<template>
	<div class="col-12">
		<div class="mb-3 text-center">
			<hr />
			<strong>مشاهده تیکت ({{(ticket || {}).title || '...'}})</strong>
			<hr />
		</div>
		<div v-if="isLoading">
			در حال دریافت اطلاعات لطفا کمی صبر کنید ...
		</div>
		<div v-else-if="!isLoading && ticket == null">
			خطا در دریافت اطلاعات
		</div>
		<div v-else class="col-12 mb-5 float-left">
			<div class="show-ticket">
				<ul class="msg col-12 col-md-10 offset-md-1 float-left border">
					<li class="notif">
						<div class="alert alert-light text-right border-bottom col-12 float-right" style="border-radius:20px;">
							<span><span class="text-info">موضوع</span> : {{ticket.ticketRequestTypeName}}</span><br />
							<span><span class="text-info">عنوان</span> : {{ticket.title}}</span><br />
							<span><span class="text-info">شماره رهگیری</span> : {{ticket.trackingCode}}</span><br />
							<span><span class="text-info">وضعیت</span> : {{ticket.statusName}}</span><br />
							<span><span class="text-info">اولویت</span> : {{ticket.ticketPriorityName}}</span><br />
							<br /><br />
							<small class='w-100'>ارسال شده در تاریخ  {{ticket.persianCreateDate}}  ساعت  {{ticket.createTime}}</small><br />
							<small v-if="ticket.customerReplyCount" class='w-100'>
								به روز رسانی شده شده در تاریخ  {{ticket.lastCustomerReplyPersianCreateDate}}  ساعت  {{ticket.lastCustomerReplyCreateTime}}
							</small>
						</div>
					</li>

					<li v-for="(msg,msgIndex) in ticket.messages" :key="msgIndex">
						<div class="w-100 float-right" v-if="msg.responder && (msgIndex == 0)">
							<ReplyTicket :ticketId="ticket.ticketId" @reply="getTicket" />
						</div>
						<div class="w-100 float-right" v-if="msg.responder">
							<div class="second">
								<div class="space">
									<label>توسط: {{msg.responder}}</label><br /><br />
									<div v-html="msg.responseContent"></div>

									<div class="bg-light mt-4" v-if="(msg.responseDocs || []).length > 0">
										<table class="table table-borderless table-sm" style="font-size:11px;">
											<tr v-for="(responseDoc,responseDocIndex) in msg.responseDocs" :key="responseDocIndex">
												<td>
													<div class="p-2 mb-2">
														<div>
															<strong>نام فایل: </strong>
															<label>{{responseDoc.originalName}}</label>
														</div>
														<div>
															<strong>نوع فایل :</strong>
															<label>{{responseDoc.docTypeDescription}} ({{responseDoc.docTypeShortType}})</label>
														</div>
														<div>
															<strong>لینک دانلود :</strong>
															<label>
																<a target="_blank" :href="`https://portal.ramnicpay.com/${responseDoc.serverPath}`">دانلود</a>
															</label>
														</div>
													</div>
												</td>
											</tr>
										</table>
									</div>
									<small>{{msg.responseCreateTime}} - {{msg.responsePersianCreateDate}}</small>
								</div>
							</div>
						</div>
						<div class="w-100 float-right">
							<div class="first">
								<div class="space">
									<label>توسط: {{customer.fullName}}</label><br /><br />
									<div v-html="msg.textContent"></div>

									<div class="bg-light mt-4" v-if="(msg.docs || []).length > 0">
										<table class="table table-borderless table-sm" style="font-size:11px;">
											<tr v-for="(doc,docIndex) in msg.docs" :key="docIndex">
												<td>
													<div class="p-2 mb-2">
														<div>
															<strong>نام فایل: </strong>
															<label>{{doc.originalName}}</label>
														</div>
														<div>
															<strong>نوع فایل :</strong>
															<label>{{doc.docTypeDescription}} ({{doc.docTypeShortType}})</label>
														</div>
														<div>
															<strong>لینک دانلود :</strong>
															<label>
																<a target="_blank" :href="`https://portal.ramnicpay.com/${doc.serverPath}`">دانلود</a>
															</label>
														</div>
													</div>
												</td>
											</tr>
										</table>
									</div>
									<small>{{msg.createTime}} - {{msg.persianCreateDate}}</small>
								</div>
							</div>
						</div>
					</li>
					<li>
						<router-link class="btn d-block btn-dark" to="/club/tickets">
							بازگشت به لیست تیکت ها
						</router-link>
					</li>
				</ul>
				<div>

				</div>
			</div>
		</div>

	</div>
</template>
<script>
	import store from "@/store";
	import ReplyTicket from "@/views/club/ReplyTicket";

	export default {

		components: {
			ReplyTicket
		},

		data()
		{
			return {
				isLoading: false,
				customer: store.customer,
				trackingCode: '',
				ticket: null,
				items: []
			};
		},

		beforeMount()
		{
			this.trackingCode =
				this.$route.params.id || ''

			if (this.trackingCode == '')
			{

				this.$router.push({
					name: "club",
					params: { action: "dashboard" }
				});
			}
			else
			{
				this.getTicket()
			}

		},

		methods: {
			getTicket()
			{
				const showError = (message) =>
				{
					message =
						message ||
						'خطا در دریافت اطلاعات تیکت، لطفا با پشتیبانی سیستم تماس حاصل فرمایید.';

					this.$bvToast.toast(message, {
						title: 'عملیات ناموفق',
						toaster: 'b-toaster-top-center',
						variant: 'danger',
						bodyClass: 'text-center',
						noCloseButton: true,
						solid: true
					})
				}

				this.isLoading = true;

				axios({ method: "post", url: "/api/App/GetTicketByTrackingCode", data: { trackingCode: this.trackingCode } })
					.then(r =>
					{
						console.log(r)
						if (r.data.success)
						{
							this.ticket = r.data.meta || null
						}
						else
						{
							showError(r.data.message)
						}

						this.isLoading = false;
					})
					.catch(error =>
					{
						showError()

						this.isLoading = false;
					});
			}
		}
	};
</script>
<style>

	.show-ticket {
		width: 100%;
		float: left;
	}


		.show-ticket .msg {
			width: 100%;
			list-style: none;
			padding: 10px 20px;
		}

			.show-ticket .msg li {
				display: block;
				position: relative;
				float: right;
				width: 100%;
				height: auto;
			}

				.show-ticket .msg li .space {
					display: block;
					min-width: 70%;
					max-width: 90%;
					width: auto;
					height: auto;
					padding: 10px 20px 10px 20px;
					overflow-wrap: break-word;
					margin-bottom: 20px;
				}

				.show-ticket .msg li time {
					display: block;
					width: auto;
					height: 32px;
					font-size: 10px;
					line-height: 32px;
					font-weight: 600;
					text-transform: uppercase;
					color: #c4c7d0;
				}

				.show-ticket .msg li .first .space {
					float: right;
					border-radius: 22px 22px 8px 22px;
					background: #fff;
					border-bottom: #2d77ca solid 1px;
					text-align: right;
				}

				.show-ticket .msg li .first ~ li .first + li .first, .chat.firstView .msg li .first + li .first {
					margin: 6px 0px 0px 0px;
				}

					.show-ticket .msg li .first ~ li .first + li .first .space, .chat.firstView .msg li .first + li .first .space {
						border-radius: 22px 8px 8px 22px;
					}

				.show-ticket .msg li .second .space {
					float: left;
					border-radius: 22px 22px 22px 8px;
					background: #fff;
					border-bottom: #ff0000 solid 1px;
					text-align: right;
				}

				.show-ticket .msg li .second ~ li .second + li .second, .chat.firstView .msg li .second + li .second {
					margin: 6px 0px 0px 0px;
				}

					.show-ticket .msg li .second ~ li .second + li .second .space, .chat.firstView .msg li .second + li .second .space {
						border-radius: 8px 22px 22px 8px;
					}

				.show-ticket .msg li.img .space {
					padding: 6px 6px 0px 6px;
				}

				.show-ticket .msg li .first.img .caption {
					float: left;
					padding: 0px 6px 10px 14px;
					color: #fff;
				}

				.show-ticket .msg li .second.img .caption {
					float: left;
					padding: 0px 14px 10px 6px;
					color: #717a90;
				}

				.show-ticket .msg li .first img {
					border-radius: 16px 16px 4px 16px;
				}

				.show-ticket .msg li .first ~ li .first + li .first img, .chat.firstView .msg li .first + li .first img {
					border-radius: 16px 4px 4px 16px;
				}

				.show-ticket .msg li .second img {
					border-radius: 16px 16px 16px 4px;
				}

				.show-ticket .msg li .second ~ li .second + li .second img, .chat.firstView .msg li .second + li .second img {
					border-radius: 4px 16px 16px 4px;
				}

				.show-ticket .msg li time {
					color: #c4c7d0;
				}

				.show-ticket .msg li .first time {
					left: 0px;
				}

				.show-ticket .msg li .second time {
					right: 0px;
				}
</style>
